import React, { useEffect } from "react";
import { selectVariant } from "../../utils/adVariant";

const SmiWidget = ({ isFull, isDesktop, blockIds, visibleWidgets }) => {
    // selectVariant пропускает скаляр насквозь, поэтому сюда можно передать
    // как per-variant словарь из бандла, так и уже отрезолвленный id из БД. Список
    // id из БД (колонка сайдбара 2013) — тоже готовое значение: selectVariant искал
    // бы в массиве ключ варианта и терял все виджеты.
    const selectedIds = Array.isArray(blockIds) ? blockIds : selectVariant(blockIds, isFull, isDesktop);
    const ids = selectedIds === null ? [] : Array.isArray(selectedIds) ? selectedIds : [selectedIds];
    const visibleIds = visibleWidgets ? ids.slice(0, visibleWidgets) : ids;

    useEffect(() => {
        visibleIds.forEach(() => {
            (window.smiq = window.smiq || []).push({});
        });
    }, [visibleIds.length]);

    if (!visibleIds.length) {
        return null;
    }

    return (
        <React.Fragment>
            {visibleIds.map((id, index) => (
                <div key={index} className="smi24__informer smi24__auto" data-smi-blockid={id}></div>
            ))}
        </React.Fragment>
    );
};

export default SmiWidget;
